import { resolveOwnerFirstName, resolveOwnerFirstNameCapitalized } from "../../content/owner-name";

/**
 * Content-Design-authored copy for the Renewal received route — screen 7
 * (TG-5, refreshed to H2; design_handoff_renewals_portal_H2/README.md
 * "Screen 7 — Confirmation and saved-for-later" and
 * screens/07-PostSubmission.dc.html). Every string below is copied byte
 * for byte from that source, with `businessName`, `ownerName` and
 * `renewalDate` substituted at render time — this screen is reused for
 * every renewal, not just H2's own "Riverside Bakery Group LLC" / "Dana
 * Whitfield" worked example.
 *
 * Four states (AC-22): `ownerSubmitted`, `ownerSaved`, `colleagueSubmitted`,
 * `colleagueSaved`. The confirmation/sent-to sentence is split into
 * prefix/suffix around the business/owner name rather than one pre-joined
 * string so the name renders with real emphasis (`<strong>`) in the DOM.
 */
export const receivedContent = {
  ownerSubmitted: {
    confirmationPrefix: "Thank you for submitting your renewal updates for ",
    confirmationSuffix: "!",
    whatHappensNextHeading: "What happens next",
    whatHappensNextPrefix: "Your Account Manager will review the information you provided and begin preparing your renewal. You can expect to receive your renewal documents before ",
    whatHappensNextSuffix: ".",
    followUp: "If we have any questions or need additional information, your Account Manager will contact you directly. Otherwise, no further action is needed at this time.",
    thanks: "Thank you for the opportunity to service your account. We appreciate your trust and look forward to our continued partnership.",
  },

  ownerSaved: {
    statusMessage: "We have saved your responses, including the section you were working on. You have not submitted your renewal yet.",
    whatHappensNextHeading: "What happens next",
    whatHappensNext: "When you are ready to finish, open your renewal email and sign in again.",
    followUp: "Please submit your renewal as soon as possible so your Account Manager has time to prepare it.",
  },

  colleagueSubmitted: {
    confirmationPrefix: "Thank you for submitting your renewal updates for ",
    confirmationSuffix: "!",
    sentToPrefix: "We have sent your responses to ",
    sentToSuffix: ", and no further action is needed from you at this time.",
    whatHappensNextHeading: "What happens next",
    whatHappensNext: (ownerName: string | null) =>
      `${resolveOwnerFirstNameCapitalized(ownerName)} will review the information provided, complete the remaining sections, and submit the renewal.`,
  },

  colleagueSaved: {
    statusMessagePrefix: "We have saved your responses, including the section you were working on. You have not sent your responses to ",
    statusMessageSuffix: " yet.",
    whatHappensNextHeading: "What happens next",
    whatHappensNext: "When you are ready to finish, open your renewal email and sign in again.",
    followUp: (ownerName: string | null) =>
      `Please send your responses as soon as possible so ${resolveOwnerFirstName(ownerName)} has time to review them and submit the renewal.`,
  },
} as const;
